//////////////////////////////////////////////////////////////////////////////////////////
//                                                                                      //
//    Designspezifische Funktionen fuer WEBSALE eCommerce                               //
//                                                                                      //
//////////////////////////////////////////////////////////////////////////////////////////



//////////////////////////////////////////////////////////////////////////////////////////
//	Allgemeine: "verfügbare Zeichen einer Textarea anzeigen"                        //
//////////////////////////////////////////////////////////////////////////////////////////
//
//	Mit folgender Funktion können Sie die restlichen verfügbaren Zeichen
//	einer Textarea anzeigen lassen:
//	ws_registerLimitTextarea(textareaid, maxlength, infodiv, infostring_signsleft, infostring_nosignsleft)
//		textareaid:		Die ID der Textarea
//		maxlength:		Die maximale Anzahl an Zeichen
//		infodiv:		Die ID des DIV-Containers in der die verfügbare Menge an Zeichen angezeigt wird
//		infostring_signsleft:	Dieser Text wird angezeigt wenn noch Zeichen zur Verfügung stehen. Das Tag ~WSJS-Signs~ wird durch die verfügbare Anzahl an Zeichen ersetzt.
//		infostring_nosignsleft:	Dieser Text wird angezeigt wenn keine Zeichen mehr zur Verfügung stehen. Das Tag ~WSJS-Signs~ wird durch die maximale Anzahl an Zeichen ersetzt.
//
//	Rufen Sie diese Funktion entweder in der Funktion $(document).ready oder an einer beliebigen Stelle im Template auf



//////////////////////////////////////////////////////////////////////////////////////////
//    Allgemein: "DIV-Container bei aktiviertem Javascript einblenden"                  //
//////////////////////////////////////////////////////////////////////////////////////////

//Alle DIV-Container mit dieser Klasse werden nachdem die Seite gealden ist automatisch eingeblendet
//Die DIV-Container muessen dabei den style "display: none" besitzen
var ws_JSOnlyClass = 'jsonly';



//////////////////////////////////////////////////////////////////////////////////////////
//    Modul: "Produkt weiterempfehlen per AJAX einbinden"                               //
//////////////////////////////////////////////////////////////////////////////////////////

//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage zum Nachladen der Eingabefelder abgesetzt wird.
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXloadProductRecmdStart()
{

}


//Diese Funktion wird aufgerufen wenn das Nachladen der Eingabefelder erfolgreich war
function ws_AJAXloadProductRecmdResponseSuccess()
{

}

//Diese Funktion wird aufgerufen wenn das Nachladen der Eingabefehler nicht erfolgreich war
function ws_AJAXloadProductRecmdResponseError()
{

}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXloadProductRecmdError()
{

}

//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage zum Absenden der Produkt weiterempfehlen Funktion abgesetzt wird
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXsendProductRecmdStart()
{

}


//Diese Funktion wird aufgerufen wenn das Absenden der Produkt-weiterempfehlen Funktion erfolgreich war
function ws_AJAXsendProductRecmdResponseSuccess()
{

}

//Diese Funktion wird aufgerufen wenn das Absenden der Produkt weiterempfehlen nicht erfolgreich war
function ws_AJAXsendProductRecmdResponseError()
{

}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXsendProductRecmdError()
{

}


//////////////////////////////////////////////////////////////////////////////////////////
//    Modul: "abhängige Varianten per AJAX nachladen"                                   //
//////////////////////////////////////////////////////////////////////////////////////////

//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage abgesetzt wird.
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXPRStart()
{

}


//Diese Funktion wird aufgerufen wenn eine abhängige Variantenkombination erfolgreich geladen werden konnte
//Mit dieser Funktion ist die Erfolgsmeldung realisierbar
function ws_AJAXPRResponseSuccess()
{

}

//Diese Funktion wird aufgerufen wenn eine abhängige Variantenkombination NICHT geladen werden konnte
//Mit dieser Funktion laesst sich die von WEBSALE eCommerce erzeugte Fehlermeldung ausgeben
function ws_AJAXPRResponseError()
{

}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXPRError()
{

}
//////////////////////////////////////////////////////////////////////////////////////////
//    Modul: "Produkte per AJAX in den Warenkorb legen"                                 //
//////////////////////////////////////////////////////////////////////////////////////////

//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage abgesetzt wird.
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXaddToBasketStart()
{

}


//Diese Funktion wird aufgerufen wenn Produkt(e) in den Warenkorb gelegt werden konnten
//Mit dieser Funktion ist die Erfolgsmeldung realisierbar
function ws_AJAXaddToBasketResponseSuccess()
{

}

//Diese Funktino wird aufgerufen wenn mindestens ein Artikel nicht in den Warenkorb gelegt werden konnte
//Mit dieser Funktion laesst sich die von WEBSALE eCommerce erzeugte Fehlermeldung ausgeben
function ws_AJAXaddToBasketResponseError()
{

}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXaddToBasketError()
{

}

//////////////////////////////////////////////////////////////////////////////////////////
//    Modul: "Produkt per AJAX auf die Merkliste setzen"                                //
//////////////////////////////////////////////////////////////////////////////////////////

//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage abgesetzt wird.
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXaddToMemolistStart()
{

}


//Diese Funktion wird aufgerufen wenn Produkt(e) auf die Merkliste gestezt werden konnten
//Mit dieser Funktion ist die Erfolgsmeldung realisierbar
function ws_AJAXaddToMemolistResponseSuccess()
{

}

//Diese Funktion wird aufgerufen wenn ein Produkt nicht auf die Merkliste gesetzt werden konnte
//Mit dieser Funktion laesst sich die von WEBSALE eCommerce erzeugte Fehlermeldung ausgeben
function ws_AJAXaddToMemolistResponseError()
{

}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXaddToMemolistError()
{

}





//////////////////////////////////////////////////////////////////////////////
//	Modul "Refresh der Adresseingabe per AJAX"   							//
//////////////////////////////////////////////////////////////////////////////

//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage zum Aktualisieren der Adresseingabe abgesetzt wird
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXRefreshAddressInputStart() {
	console.log('AJAX START');
	$('a.deliv_selection_label').addClass('disabled'); // wird am Ende des AJAX-Requests durch das Ersetzen des DOM-BLocks durch den neuen DOM-Block vom Server überschrieben
	// on('click',function(){return false;})
}

//Diese Funktion wird aufgerufen wenn das Absenden zum Aktualisieren der Adresseingabe erfolgreich war
function ws_AJAXRefreshAddressInputResponseSuccess() {
	console.log('AJAX SUCCESS');
}

//Diese Funktion wird aufgerufen wenn das Absenden zum Aktualisieren der Adresseingabe nicht erfolgreich war
function ws_AJAXRefreshAddressInputResponseError() {
	console.log('AJAX ERROR SHOP');
}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXRefreshAddressInputError(){
	console.log('AJAX ERROR NETWORK');
	// error handling:
	// make tabs active again:
	$('a.deliv_selection_label').removeClass('disabled');
	// revert tab selection:
	var radio_button_state = ( $('input:radio[name="ws_input_delivery_suffix4"]:checked').val()==='01' ) ? 0 : 1;
	$('a.deliv_selection_label').eq( (radio_button_state===1) ? 0 : 1 ).closest('li').tab('show'); // radio is 01 or 02, therefore revert tab to 1 or 0
	// revert (hidden) radio button selection:
	$('input:radio[name="ws_input_delivery_suffix4"]').eq( (radio_button_state===1) ? 0 : 1 ).prop('checked', true);
}





//////////////////////////////////////////////////////////////////////////////
//	Modul "Refresh der Bankdateneingabe per AJAX"   					    //
//////////////////////////////////////////////////////////////////////////////
//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage zum Aktualisieren der Bankdateneingabe abgesetzt wird
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXRefreshBankInputStart()
{

}


//Diese Funktion wird aufgerufen wenn das Absenden zum Aktualisieren der Bankdateneingabe erfolgreich war
function ws_AJAXRefreshBankInputResponseSuccess()
{

}

//Diese Funktion wird aufgerufen wenn das Absenden zum Aktualisieren der Bankdateneingabe nicht erfolgreich war
function ws_AJAXRefreshBankInputResponseError()
{

}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXRefreshBankInputError()
{

}





//////////////////////////////////////////////////////////////////////////////
//	Modul "Refresh der Kreditkarteneingabe per AJAX"   					    //
//////////////////////////////////////////////////////////////////////////////
//Diese Funktion wird aufgerufen bevor die AJAX-Anfrage zum Aktualisieren der Kreditkartendateneingabe abgesetzt wird
//Mit dieser Funktion ist zum Beispiel eine Ladeanzeige realisierbar
function ws_AJAXRefreshCCInputStart()
{

}


//Diese Funktion wird aufgerufen wenn das Absenden zum Aktualisieren der Kreditkartendateneingabe erfolgreich war
function ws_AJAXRefreshCCInputResponseSuccess()
{

}

//Diese Funktion wird aufgerufen wenn das Absenden zum Aktualisieren der Kreditkartendateneingabe nicht erfolgreich war
function ws_AJAXRefreshCCInputResponseError()
{

}

//Diese Funktion wird aufgerufen wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function ws_AJAXRefreshCCInputError()
{

}
//////////////////////////////////////////////////////////////////////////////////////////
//    Modul: "Produktvergleich"                                                         //
//////////////////////////////////////////////////////////////////////////////////////////
//Anhand der nachfolgenden Parameter laesst sich das Verhalten des Produktvergleichs konfigurieren

//Der DIV-Container in dem der Inhalt des Layers (Produktvergleich) angezeigt wird (Kategorie/Produkt)
var ws_PRCAjaxDivContent = 'PC-Content';

//Der Klassenname der Links zum Anzeigen des Produktvergleichs
//dieser DIV-Container muss einmal auf jedem Template vorhanden sein auf dem der Produktvergleich angezeigt wird.
var ws_PRCShowProductCompareClass = 'PRC-Show';

//Der DIV-Container mit dieser ID wird eingeblendet wenn eine Hinweismeldungen angezeigt wird, z.B. wenn keine weiteren Produkte zum Produktvergleich hinzugefuegt werden koennen (Kategorie)
var ws_PRCAlertDiv = 'PC-Alert';
//In den DIV-Container mit dieser ID wird der Hinweistext eingefuegt (Kategorie)
var ws_PRCAlertTextDiv = 'PC-Alert-Message';

//Ist dieser Schalter auf true gesetzt wird der Inhalt des Produktvergleichs per JavaScript um 90 Grad gedreht
var ws_PRCRotate = true;
//Anfang und Endekennungen der Daten- und Template-Sektion im Template welches per AJAX zurueckgegeben wird
var ws_PRCRotateDataBegin = '<data>';
var ws_PRCRotateDataEnd = '</data>';
var ws_PRCRotateTemplateBegin = '<template>';
var ws_PRCRotateTemplateEnd = '</template>';
//Feld- und Datensatztrenner der Datensektion
var ws_PRCRotateDataFieldSeparator = '<df>';
var ws_PRCRotateDataRowSeparator = '<dr>';
//Konfiguration der Ausgabetabelle
var ws_PRCRotateTableClass = 'PRC-Table';
var ws_PRCRotateTableID = 'PRC-Table';
var ws_PRCRotateTableTRClasses = [ 'PRC-TR1', 'PRC-TR2' ];                         //Array mit beliebiger Anzahl an Klassen
var ws_PRCRotateTableTDHeaderClasses = [ 'PRC-TDHeader1', 'PRC-TDHeader2' ];       //Array mit beliebiger Anzahl an Klassen
var ws_PRCRotateTableTDClasses = [ 'PRC-TD1', 'PRC-TD2' ];                         //Array mit beliebiger Anzahl an Klassen
var ws_PRCRotateTableTDClassesAlternateVertical = true;
var ws_PRCRotateTemplateReplaceTag = '#####REPLACE#####';


//////////////////////////////////////////////////////////////////////////////
//	Modul "W2P Init per AJAX"   //
//////////////////////////////////////////////////////////////////////////////

//Beispiel für einen Success-Callback
//function w2pInitAjaxSuccess(data)
//{
//  //Auf Fehler prüfen
//  if (data.Result == 0)
//  {
//		location.href = data.w2purl + "&w2pdata=" + data.w2pdata;
//  }
//  else
//  {
//		//Individuelle Fehlerbehandlung
//  }
//}








function ws_AJAXloadProdRatingStart() {
	// console.log('ws_AJAXloadProdRatingStart');
	//Ausblenden von Inhalts- und Fehlercontainer, Einblenden des Ladecontainers
	$('#ws_prodrating_error').hide();
	$('#ws_prodrating_content').hide();
	$('#ws_prodrating_loading').show();
	$('#ws_prodrecmd_content').hide();
	$('#ws_inquiry_content').hide();
	$("#ws_lawdeclaration_content").hide();
}

//Diese Funktion wird aufgerufen, wenn das Nachladen des Formulars erfolgreich war
function ws_AJAXloadProdRatingResponseSuccess() {
	// console.log('ws_AJAXloadProdRatingResponseSuccess');
	//Ausblenden von Lade- und Fehlercontainer, Einblenden des Inhaltscontainers
	$('#ws_prodrating_error').hide();
	$('#ws_prodrating_loading').hide();
	$('#ws_prodrating_content').show();
	$('#ws_prodrecmd_content').hide();
	$('#ws_inquiry_content').hide();
	$("#ws_lawdeclaration_content").hide();
}

//Diese Funktion wird aufgerufen, wenn das Nachladen der Eingabefehler nicht erfolgreich war
function wsAJAXloadProdRatingResponseError() {
	// console.log('wsAJAXloadProdRatingResponseError');
	//Ausblenden von Lade- und Fehlercontainers, Einblenden des Inhaltscontainer
	$('#ws_prodrating_error').hide();
	$('#ws_prodrating_loading').hide();
	$('#ws_prodrating_content').show();
	$('#ws_prodrecmd_content').hide();
	$('#ws_inquiry_content').hide();
	$("#ws_lawdeclaration_content").hide();
}

//Diese Funktion wird aufgerufen, wenn die AJAX-Kommunikation fehlschlug
//Mit dieser Funktion laesst sich ein allgemeiner Kommunikationsfehler (z.B. wenn die Internetverbindung unterbrochen wurde) anzeigen
function wsAJAXloadProdRatingError() {
	// console.log('wsAJAXloadProdRatingError');
	//Ausblenden von Lade- und Inhaltscontainer, Einblenden des Fehlercontainers
	$('#ws_prodrating_loading').hide();
	$('#ws_prodrating_content').hide();
	$('#ws_prodrating_error').show();
}
